import angular from 'angular';
import csmCommonWeb from 'csm-common-web';

import { inventoryProduct } from './InventoryProduct'
import { entityListItem } from './EntityListItem';

export default angular
  .module('books.data', [csmCommonWeb])
  .factory("InventoryProduct", inventoryProduct)
  .factory("EntityListItem", entityListItem)
  .name;
